import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResolvedItemCache } from '@scisys-uim/uim-common';
import { RefCodeService } from './ref-code.service';
import { RefCode } from 'assets-model';

export interface RefCodeMap {
  [Key: string]: {
    [Key: string]: RefCode;
  };
}

@Injectable({
  providedIn: 'root',
})
export class RefCodeStorage extends ResolvedItemCache<RefCodeMap> {

  constructor(protected service: RefCodeService) {
    super(null);
  }

  public reResolve(): Observable<RefCodeMap> {
    return this.service.findAll().pipe(map(codes => {
      if (codes != null && codes.items != null && codes.items.length) {
        const result: RefCodeMap = {};
        codes.items.forEach(code => addRefCode(code, result));
        return result;
      }
      return null;
    }));
  }

  getDomain(domain: string): Observable<{ [Key: string]: RefCode; }> {
    return this.resolve().pipe(map(map => {
      if (map && map[domain]) {
        return map[domain];
      }
      return null;
    }));
  }

  getDomainElements(domain: string): Observable<RefCode[]> {
    return this.getDomain(domain).pipe(map(map => {
      if (map) {
        return Object.values(map);
      }
      return [];
    }));
  }

  lookup(domain: string, key: string): Observable<RefCode> {
    return this.resolve().pipe(map(map => {
      if (map && map[domain]) {
        return map[domain][key];
      }
      return null;
    }));
  }

  decode(domain: string, key: string, fallbackOnKey?: boolean): Observable<string> {
    return this.lookup(domain, key).pipe(map(code => {
      return code ? code.meaning : (fallbackOnKey ? key : null);
    }));
  }
}

function addRefCode(code: RefCode, map: RefCodeMap) {
  map[code.domain] = map[code.domain] || {};
  map[code.domain][code.code] = code;
}
